import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './phoneFilter.json';

const getPhoneFilterSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['phoneFilterController/getPhoneFilterSetting'].success.default)));
};
const getPhoneIdentifySetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['phoneFilterController/getPhoneIdentifySetting'].success.default)));
};

const queryBlackListSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['phoneFilterController/queryBlackListSetting'].success.default)));
};

const updateBlackListSetting = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['phoneFilterController/updateBlackListSetting'].success.default)));
};

const phoneFilterSettingResult = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['PhoneFilterController/phoneFilterSettingResult'].success.default)));
};

const phoneIdentifySettingResult = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['PhoneFilterController/phoneIdentifySettingResult'].success.default)));
};

export const handlers = [
  rest.post(
    getApiEndpoint('PhoneFilterController/getPhoneFilterSetting'),
    withScenario(withAuthCheck(getPhoneFilterSetting))
  ),
  rest.post(
    getApiEndpoint('PhoneFilterController/getPhoneIdentifySetting'),
    withScenario(withAuthCheck(getPhoneIdentifySetting))
  ),
  rest.post(
    getApiEndpoint('PhoneFilterController/queryBlackListSetting'),
    withScenario(withAuthCheck(queryBlackListSetting))
  ),
  rest.post(
    getApiEndpoint('PhoneFilterController/updateBlackListSetting'),
    withScenario(withAuthCheck(updateBlackListSetting))
  ),
  rest.post(
    getApiEndpoint('PhoneFilterController/phoneFilterSettingResult'),
    withScenario(withAuthCheck(phoneFilterSettingResult))
  ),
  rest.post(
    getApiEndpoint('PhoneFilterController/phoneIdentifySettingResult'),
    withScenario(withAuthCheck(phoneIdentifySettingResult))
  ),
];
